<script setup>
import { computed } from 'vue';
import { usePropertyManagerContact } from '../../composables/usePropertyManagerContact.js';
import { useSiteBrand } from '../../composables/useSiteBrand.js';

const { manager } = usePropertyManagerContact();
const { siteName } = useSiteBrand();

/** Published manager company name; falls back to site name when unset. */
const companyName = computed(() => {
  const company = (manager.value?.companyName || '').trim();
  if (company) return company;
  return (siteName.value || '').trim();
});
</script>

<template>{{ companyName }}</template>
